// extracted by mini-css-extract-plugin
export var drawerPaper = "_1s-0";
export var itemImage = "_1s-1";